import { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PersonaValidatedBannerProps {
	show: boolean;
}

export function PersonaValidatedBanner({ show }: PersonaValidatedBannerProps) {
	const [dismissed, setDismissed] = useState(false);

	useEffect(() => {
		if (show) setDismissed(false);
	}, [show]);

	if (!show || dismissed) return null;

	return (
		<div className='sticky bottom-0 flex items-center gap-3 rounded-[20px] border border-border bg-white/80 p-3 shadow-[0px_-3px_12px_0px_rgba(0,0,0,0.12)] backdrop-blur-[6px]'>
			<div className='flex flex-1 items-center gap-3 min-w-0'>
				<Check className='size-6 shrink-0 text-green-500' strokeWidth={2} />
				<p className='text-sm font-medium text-foreground'>Persona Validated</p>
			</div>
			<Button variant='ghost' size='sm' className='h-7 rounded-full px-3 text-xs text-muted-foreground' onClick={() => setDismissed(true)}>
				Dismiss
			</Button>
		</div>
	);
}
